/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const Credentials = {

	getUserExist (context, token, onSuccess, onError, options) {
		Api.get(context,
			"/credentials/user-exist"
			+ "?token=" + token
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getUserExistsByEmailToken (context, token, onSuccess, onError, options) {
		Api.get(context,
			"/credentials/user-exists-by-email-token"
			+ "?token=" + token
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postSendPasswordSetupEmail (context, passwordSetupEmailDTO, onSuccess, onError, options) {
		Api.post(context,
			"/credentials/send-password-setup-email"
			, passwordSetupEmailDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postSetupPassword (context, setupPasswordDTO, onSuccess, onError, options) {
		Api.post(context,
			"/credentials/setup-password"
			, setupPasswordDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putResetEmail (context, resetEmailDTO, onSuccess, onError, options) {
		Api.put(context,
			"/credentials/reset-email"
			, resetEmailDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putResetPassword (context, resetPasswordDTO, onSuccess, onError, options) {
		Api.put(context,
			"/credentials/reset-password"
			, resetPasswordDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putSetupNewBidderEmail (context, setupUserEmailDTO, onSuccess, onError, options) {
		Api.put(context,
			"/credentials/setup-new-bidder-email"
			, setupUserEmailDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putSetupUserEmail (context, setupUserEmailDTO, onSuccess, onError, options) {
		Api.put(context,
			"/credentials/setup-user-email"
			, setupUserEmailDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
